import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SegmentValidationComponent } from './segment-validation/segment-validation.component';
import { SegmentValidationService } from './segment-validation/segment-validation.service';


@NgModule({
    imports: [CommonModule],
    declarations: [
        SegmentValidationComponent
    ],
    exports: [
        SegmentValidationComponent
    ],
    providers: [SegmentValidationService]
})
export class ValidationModule { }
